export const Strings_FR = {
  thwaitesglacier: 'FR_Thwaites-Gletscher',
  antarctica: 'FR_Antarktis',
  southpole: 'FR_Südpol',
  southamerica: 'FR_Südamerika',
  weddelsea: 'FR_Weddellmeer',
  rossea: 'FR_Rossmeer',
  belowsealevel:"FR_Grosse Teile der westantarktischen Landmasse liegen unterhalb des Meerespiegels."

}
